import React, { useEffect, useRef, useState } from 'react';
import DailyBriefCard from '../../DailyBriefCard';
import MailWidget from '../../mail/MailWidget';
import CalendarStrip from '../../mail/CalendarStrip';
import OpsCells from '../../OpsCells';
import ToolCribTiles from '../../ToolCribTiles';
import TimeOffCard from '../../TimeOffCard';
import MySheetSchedule from '../../MySheetSchedule';
import FleetAlertsCard from '../../FleetAlertsCard';
import { MyDispatches, MyFieldWeek, DashboardAnnouncements, DashboardPeopleEvents, FinancialDashboard, HRDashboard, ForemanDashboard, WorkerDashboard } from '../../Dashboard';

// Existing dashboard cards, re-homed as widgets. The wrapper strips their page margins so they fill the tile.
const wrap = (Comp, needsUser = false, emptyText = 'Nothing to show right now.') => function Legacy({ user }) {
  const ref = useRef(null);
  const [empty, setEmpty] = useState(false);
  useEffect(() => {
    const check = () => setEmpty(!!ref.current && ref.current.childElementCount === 0);
    const t = setTimeout(check, 1500);
    const iv = setInterval(check, 4000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, []);
  return (
    <div className="legacy-widget h-full overflow-y-auto no-drag relative">
      <div ref={ref}>{needsUser ? <Comp user={user} /> : <Comp />}</div>
      {empty && <p className="absolute inset-0 flex items-center justify-center text-xs text-slate-400 px-4 text-center" data-testid="legacy-empty">{emptyText}</p>}
    </div>
  );
};

export const DailyBrief = wrap(DailyBriefCard);
export const Mail = wrap(MailWidget, false, 'Mail is not connected for your account — open Mail to sign in with Google.');
export const Calendar = wrap(CalendarStrip);
export const Ops = wrap(OpsCells);
export const ToolCrib = wrap(ToolCribTiles);
export const TimeOff = wrap(TimeOffCard, false, 'No time-off info to show.');
export const MySchedule = wrap(MySheetSchedule, true);
export const Fleet = wrap(FleetAlertsCard, false, 'No fleet alerts — every truck is in good standing.');
export const Dispatches = wrap(MyDispatches, false, 'You are not dispatched anywhere right now.');
export const FieldWeek = wrap(MyFieldWeek);
export const Announcements = wrap(DashboardAnnouncements);
export const PeopleEvents = wrap(DashboardPeopleEvents, false, 'No birthdays or anniversaries coming up.');
export const Financial = wrap(FinancialDashboard, true);
export const HR = wrap(HRDashboard, true);
export const Foreman = wrap(ForemanDashboard, true);
export const Worker = wrap(WorkerDashboard, true);
